<!-- @file 拼手气红包组件 -->
<template>
  <div class="plv-ia-rpr-send__content--send-random">
    <!-- 总金额输入框 -->
    <cell
      v-model="curAccount"
      :title="langData.title"
      :special-title="t('plvIA.redpacketRain.ping')"
      :placeholder="langData.titlePlaceholder"
      input-type="number"
      required
      :unit="langData.titleUnit"
    >
      <!-- 快速选取金额 -->
      <div class="plv-ia-rpr-send__quick">
        <span
          v-for="account in defaultAccounts"
          :key="account.value"
          @click="setQuickAccount(account.value)"
        >{{ account.label }}</span>
      </div>
    </cell>

    <cell
      v-model="rpCount"
      :title="t('plvIA.redpacketRain.quantity')"
      :unit="t('plvIA.redpacketRain.ge')"
      input-type="text"
      :is-round="curPayType === payTypes.point"
      :placeholder="t('plvIA.redpacketRain.enterNumber')"
      required
    />
    <div class="plv-ia-rpr-send__quick-online">
      <span>{{ t('plvIA.redpacket.currently') }} <span class="plv-ia-rpr-send__quick-online--number">{{ onlineUserNumber }}</span> {{ t('plvIA.redpacket.personOnline') }}</span>
    </div>
  </div>
</template>

<script>
import redpacketBaseData from '../mixins/redpacket-base-data';
import { RANDOM_MAX_ACCOUNT, RANDOM_MAX_COUNT } from '../config';
import Cell from './cell';
import Locale from '@/mixins/locale';

export default {

  components: {
    Cell
  },
  mixins: [Locale, redpacketBaseData],

  props: {
    curPayType: {
      type: String,
    },
    onlineUserNumber: {
      type: Number,
      default: 1,
    },
    defaultAccounts: {
      type: Array,
      default: () => {
        return [];
      }
    },
    pointUnit: {
      type: String,
      default: '积分'
    },
    /** 拼手气红包总金额上限 */
    maxTotalAmount: {
      type: Number,
      default: RANDOM_MAX_ACCOUNT
    },
    /** 拼手气红包红包数量上限 */
    maxCount: {
      type: Number,
      default: RANDOM_MAX_COUNT
    },
    availableScore: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      curAccount: '',
      rpCount: '',
    };
  },

  computed: {
    maxAmount() {
      return typeof this.maxTotalAmount === 'number' && this.maxTotalAmount > 0 ? this.maxTotalAmount : RANDOM_MAX_ACCOUNT;
    },
    maxTotalCount() {
      return typeof this.maxCount === 'number' && this.maxCount > 0 ? this.maxCount : RANDOM_MAX_COUNT;
    },

    langData() {
      const data = {
        title: '',
        titlePlaceholder: '',
        titleUnit: '',
      };
      switch (this.curPayType) {
        case this.payTypes.cash:
          data.title = this.t('plvIA.redpacketRain.total');
          data.titlePlaceholder = this.t('plvIA.redpacketRain.atleast');
          data.titleUnit = this.t('plvIA.redpacketRain.cny');
          break;
        case this.payTypes.point:
          data.title = this.t('plvIA.redpacketRain.totalPoint', { unit: this.pointUnit });
          data.titlePlaceholder = this.t('plvIA.redpacketRain.atleastPoint');
          data.titleUnit = this.t('plvIA.redpacketRain.ge');
          break;
      }
      return data;
    },
  },

  watch: {
    curAccount() {
      this.handleAccountLimit();
      this.$emit('refresh-total');
      this.$emit('check-error');
    },
    rpCount() {
      this.handleCountLimit();
      this.$emit('refresh-total');
      this.$emit('check-error');
    }
  },

  methods: {
    // 设置快捷金额
    setQuickAccount(val) {
      this.curAccount = val;
    },

    // 重置
    resetData() {
      this.curAccount = '';
    },

    /**
     * 对金额/积分限制输入
     */
    handleAccountLimit() {
      switch (this.curPayType) {
        case this.payTypes.cash:
          this.handleCashLimit();
          break;
        case this.payTypes.point:
          this.handlePointLimit();
          break;
      }
    },

    /** 金额限制 */
    handleCashLimit() {
      let finalVal = this.curAccount;
      const maxAmount = this.maxAmount;
      // 是否超出最大值
      if (finalVal > maxAmount) {
        finalVal = maxAmount;
        this.$iaMessage.default(
          this.t('plvIA.redpacket.toast1', { t: maxAmount })
        );
      }

      // 是否含有小数点
      if (finalVal % 1 !== 0) {
        finalVal = finalVal.toString().match(/^\d+(?:\.\d{0,2})?/);
      }

      this.$nextTick(() => {
        this.curAccount = finalVal === '' ? finalVal : Number(finalVal);
      });
    },

    /** 积分限制 */
    handlePointLimit() {
      let finalVal = this.curAccount;

      // 是否超出可用最大值
      if (finalVal > this.availableScore) {
        finalVal = this.availableScore;
        this.$iaMessage.default(
          `${this.t('plvIA.redpacketRain.toast5')}${this.availableScore}`
        );
      }

      // 积分数值取整
      finalVal = Math.ceil(finalVal);

      this.$nextTick(() => {
        this.curAccount = finalVal === '' ? finalVal : Number(finalVal);
      });
    },

    /**
     * 对红包数量限制输入
     */
    handleCountLimit() {
      let finalVal = this.rpCount;
      const maxCount = this.maxTotalCount;
      // 是否超出最大值
      if (finalVal > maxCount) {
        finalVal = maxCount;
        this.$iaMessage.default(
          this.t('plvIA.redpacket.toast2', { t: maxCount })
        );
      }
      this.$nextTick(() => {
        this.rpCount = finalVal === '' ? finalVal : Number(finalVal);
      });
    }
  }
};
</script>

<style lang="scss">
//.plv-ia-rpr-send__content--send-random {
//  padding: 0 70px 0 0;
//}
.plv-ia-rpr-send__quick {
  margin-top: 10px;
  width: 100%;
  display: flex;
  span {
    line-height: 32px;
    background: #e9ecee;
    border: 1px solid #cfd8dc;
    text-align: center;
    width: 72px;
    font-size: 12px;
    color: #333;
    margin-right: 8px;
    cursor: pointer;
    &:last-of-type {
      margin-right: 0;
    }
  }
}
.plv-ia-rpr-send__quick-online {
  padding-left: 100px;
  margin-top: 4px;
  color: #9E9E9E;
}
.plv-ia-rpr-send__quick-online--number {
  color: #4caaf5;
}
</style>
